import React from "react";
import ProductImageCarousel from "./ProductImageCarousel";
import ProductDetails from "./ProductDetails";
import HelpSection from "./HelpSection";
import ProductImageCarousel2 from "../assets/Amethyst_Band_2.jpg";
import ProductImageCarousel1 from "../assets/Amethyst_Band_4.jpg";

const ProductDetailsById = () => {
  const product = {
    name: "Authentic Amethyst Mystic Band",
    discount: "64%",
    price: 599,
    originalPrice: 1299,
    offerCode: "NAMASTE",
    offerDetails: "Free 5 Mukhi Rudraksha worth ₹399",
    additionalInfo: "Get Siddh/Energized Product (Pran Pratistha) + ₹100",
    codButtonText: "ADD TO CART",
    onlinePayButtonText: "BUY NOW",
  };

  const help = {
    workingHours: "Mon to Sat 10 AM to 5 PM",
    whatsappOrder: "Order on WhatsApp",
    contact: "WA Chat: +91 9893 310 906",
    email: "support@vastuauraaligners.com",
  };

  // Correctly define the images and thumbnails
  const images = [ProductImageCarousel1];
  const thumbnails = [ProductImageCarousel1, ProductImageCarousel2]; // Use appropriate thumbnail URLs if different

  return (
    <div className="container mt-5 bg-white">
      <div className="row pt-5">
        <div className="col-md-6">
          <ProductImageCarousel images={images} thumbnails={thumbnails} />
        </div>
        <div className="col-md-6">
          <ProductDetails product={product} />
          <HelpSection help={help} />
        </div>
      </div>
    </div>
  );
};

export default ProductDetailsById;
